import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Page, ProdutoFabricante } from 'eddydata-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProdutoFabricanteService extends BaseResourceService<ProdutoFabricante> {

  constructor(
    protected injector: Injector
  ) {
    super(`produto-fabricantes`, injector);
  }

  public filtrarComProduto(pagina: number, limite: number, filtros: {}): Observable<Page> {
    let relations: string = filtros['relations'];
    if (relations) {
      if (!relations.includes('produto.material.sub_grupo.grupo'))
        relations = `${relations},produto.material.sub_grupo.grupo`;
    } else {
      relations = `produto.material.sub_grupo.grupo`;
    }
    filtros['relations'] = relations;

    return this.filtrar(pagina, limite, filtros);
  }
}
